/** Extant means "still exists", existent is the correct word */
export function isExistent<T>(
  arg?: T | null | undefined,
): arg is NonNullable<T> {
  return arg !== undefined && arg !== null
}
